import { app } from '../../../app';
import { Controller } from './extension-alert.controller';

app.component('publicExtensionAlert', {
    controller: Controller,
    templateUrl: require('./extension-alert.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/public/extension-alert/extension-alert.component.js